export default {"src":"/_next/static/media/outbound_noloop.e1923dfc.gif","height":480,"width":1019,"blurWidth":0,"blurHeight":0};